module.exports = __webpack_public_path__ + "static/media/doctor-profile-default.c5b92ca1.png";